<template>
  <div
    :class="classObj"
    class="app-wrapper"
  >
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    ></div>
    <sidebar class="sidebar-container" />
    <div
      :class="{ hasTagsView: needTagsView }"
      class="main-container"
    >
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <Profile />
      <updatePassword />
      <!-- <right-panel v-if="showSettings">
        <settings />
      </right-panel>-->
    </div>
    <TaskCenter />
    <ExceptionDialogVue
      v-model="form"
      :dialog-visible="exceptionDialogVisi"
      :exception-list="exceptionList"
      @close="exceptionDialogVisi = false"
    />
    <AgreementLogDialogVue />
    <div
      v-if="projectItem.isDeadline"
      class="deadlineBox"
    >
      <div class="content">
        <div class="title">
          启用有效期过期通知
        </div>
        <div class="wrapping">
          <div class="label">
            项目名称：
          </div>
          <div class="value">
            {{ projectItem.projectName }}
          </div>
        </div>
        <div class="wrapping">
          <div class="label">
            启用有效期：
          </div>
          <div class="value">
            {{
              projectItem.deadlineStartDate &&
                projectItem.deadlineStartDate.split(' ')[0]
            }}
            ~
            {{
              projectItem.deadlineEndDate &&
                projectItem.deadlineEndDate.split(' ')[0]
            }}
          </div>
        </div>
        <div class="tips">
          该项目不在有效期内，无法使用，请联系管理人员处理
        </div>
      </div>
      <div class="projectSearchWrap">
        <ProjectSearch />
      </div>
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import TaskCenter from './components/TaskCenter/index.vue'
import Profile from './components/profile/Profile.vue'
import updatePassword from './components/profile/UpdatePassword.vue'
import { exceptionByProject } from '@/api/personnel'
import ExceptionDialogVue from './components/AgreementException/ExceptionDialog.vue'
import AgreementLogDialogVue from './components/AgreementException/AgreementLogDialog.vue'
import { querySiteProject } from '@/api/dashboard'
import ProjectSearch from './components/projectSearch.vue'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    TaskCenter,
    Profile,
    updatePassword,
    ExceptionDialogVue,
    AgreementLogDialogVue,
    ProjectSearch
  },
  mixins: [ResizeMixin],
  data() {
    return {
      exceptionDialogVisi: false,
      exceptionList: [],
      form: {}
    }
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
      projectItem: (state) => state.user.projectItem
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  created() {
    this.getExceptionByProject()
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    getExceptionByProject() {
      Promise.all([
        querySiteProject({ projectId: this.projectItem.projectId }),
        exceptionByProject({
          projectId: this.projectItem.projectId
        })
      ]).then((res) => {
        this.form = res[0].data
        this.exceptionList = res[1].data
        if (res[1].data && res[1].data.length) {
          this.exceptionDialogVisi = res[1].data.some(
            (element) => element.exceptionRecordCount > 0
          )
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.deadlineBox {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  .content {
    background: #fff;
    margin: 0 auto;
    margin-top: 24vh;
    width: 534px;
    border-radius: 4px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);
    padding-bottom: 50px;
    .title {
      font-size: 16px;
      color: #262626;
      font-weight: bold;
      padding-left: 20px;
      padding-top: 16px;
      margin-bottom: 40px;
    }
    .wrapping {
      display: flex;
      padding-left: 94px;
      color: #919191;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .tips {
      color: #919191;
      font-size: 14px;
      padding-left: 94px;
      margin-top: 40px;
    }
  }
  .projectSearchWrap {
    position: absolute;
    top: 1.7vh;
    right: 18.5%;
  }
}
</style>
